import { render, staticRenderFns } from "./DownloadTransactionNfc.vue?vue&type=template&id=69f31d65"
import script from "./DownloadTransactionNfc.vue?vue&type=script&lang=js"
export * from "./DownloadTransactionNfc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports